import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext, ToastrContext } from '../../contexts';
import { fetchFaqV2ById, submitUpdateFaq, successAction } from './actions';
import FormFaqSubpangkalan from './FormFaqSubpangkalan';

export default function FormEditSubpangkalan(
  // {
  //   type = null
  // }
) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);
  const [afterSubmit, setAfterSubmit] = useState(false);

  const {
    faqId = ''
  } = queryString.parse(location.search.replace('?', ''));

  useEffect(() => {
    setBreadcrumbs(['Pengaturan FAQ', 'Edit FAQ Subpangkalan']);
    dispatch(successAction(null, 'FaqById'));
    if (faqId) {
      dispatch(fetchFaqV2ById(faqId));
    }
  }, [faqId]);

  const {
    dataSubmitUpdateFaq,
    isLoadingSubmitUpdateFaq,
    messageSubmitUpdateFaq
  } = useSelector((s) => s.faq);

  useEffect(() => {
    if (afterSubmit && !isLoadingSubmitUpdateFaq) {
      if (dataSubmitUpdateFaq) {
        setToastr({
          desc: 'FAQ Berhasil diubah',
          type: 'success',
          visible: true,
        });
        navigate('/faq?tab=subpangkalan');
      } else if (messageSubmitUpdateFaq) {
        setToastr({
          desc: 'FAQ Gagal diubah',
          type: 'danger',
          visible: true,
        });
      }
    }
  }, [dataSubmitUpdateFaq, isLoadingSubmitUpdateFaq, messageSubmitUpdateFaq]);

  const handleSubmit = (values) => {
    dispatch(submitUpdateFaq(
      faqId,
      values,
      () => setAfterSubmit(true),
      true
    ));
  };

  return (
    <FormFaqSubpangkalan
      onSubmit={handleSubmit}
      type="edit"
    />
  );
}

FormEditSubpangkalan.propTypes = {
  type: PropTypes.string,
};
